<template>
  <div class="modal-content border-0 shadow">
    <div class="modal-header border-0 bg-white rounded-top py-3">
      <button
        type="button"
        class="btn-close ms-auto"
        @click="closeModal"
      />
    </div>

    <div class="modal-body bg-white px-4 pb-4 pt-0">
      <div class="col-12 col-md-9 mx-auto">
        <div class="d-flex mx-auto">
          <img
            :src="`${aws}/unicorn-feather.png`"
            class="mx-auto mb-3"
          >
        </div>
        <h5 class="text-center mb-3">
          Ajouter un compte bancaire
        </h5>
        <p class="text-center text-md-start mb-4">
          Ajoutez votre compte bancaire pour faciliter vos paiements futurs
        </p>

        <v-gocardless-iban
          ref="bankAccountForm"
          :price="0"
          :is-setup-mode="true"
          @payment:success="onBankAccountAdded"
          @form:error="onFormError"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ui } from '@/mixins';
import GoCardlessIban from '@/components/checkout/gocardless/GoCardlessIban.vue';

export default {
  name: 'BankAccountModal',
  components: {
    'v-gocardless-iban': GoCardlessIban,
  },
  mixins: [ui],
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    hasSetPassword() {
      return this.$store.getters['client/hasSetPassword'];
    },
  },
  methods: {
    closeModal() {
      this.ui_showModal(false);
      if (!this.hasSetPassword) {
        this.$store.dispatch('ui/showModalPassword');
      }
    },
    onBankAccountAdded() {
      this.ui_showToast({
        show: true,
        message: 'Compte bancaire ajouté avec succès !',
      });

      this.closeModal();
    },
    onFormError(error) {
      console.error('[BankAccountModal] Bank account form error:', error);

      this.ui_showToast({
        show: true,
        message: 'Erreur lors de l\'ajout du compte bancaire',
      });
    },
  },
};
</script>

<style scoped>
.modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
</style>
